// extracted by mini-css-extract-plugin
export default {"modalIntro":"styles_modalIntro__H95KL"};